// @styles
require('./aggregatorCredentialsPSD2Styles.scss')

// @vendors
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
const PropTypes = require('prop-types');

// @components
import AggregatorAddEntityLayout from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityLayout/aggregatorAddEntityLayout';
import { OKSectionBox } from 'commonsComponents/OKSectionBox';
import { OKButton } from 'components/commons/OKButton/OKButton';

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
import Storage from 'utilities/storage';
import getBreadCrumbSettings from 'utilities/aggregator/getRenewTokenBreadCrumbSettings';

// @constants
import { SELECTED_BANK } from 'constants/aggregator/localStorageKeys';
const {
    recordPath,
    recordLink,
    PROC_AGGREGATOR_ENTITY_ERROR,
    PROC_AGGREGATOR_RENEW_ENTITY_GO_TO_BLOQUED_USER,
    PROC_ADD_ENTITY,
    PROC_GO_ERROR_STEP,
    PROC_AGGREGATOR,
    PROC_ERROR_RETRY
} = require('utilities/tagging');

class AggregatorRenewCredentialsPSD2Ko extends Component {

    constructor() {
        super();
        const { bankName, bankCode } = Storage.localStorage.get(SELECTED_BANK) || {};
        this.state = { bankName, bankCode, attempts: 0 }
        this.handleGoToEntityCredentials = this.handleGoToEntityCredentials.bind(this);
        this.handleGoToOtherBanksSettings = this.handleGoToOtherBanksSettings.bind(this);
    }

    componentDidMount() {
        recordPath(PROC_AGGREGATOR_ENTITY_ERROR,null ,PROC_ADD_ENTITY, PROC_GO_ERROR_STEP)
    }

    getPOEditorKey = attempts => {
        switch (attempts) {
            case 2:
                return 'aggregatorPSD2-credentialsKoTwoAttempts'
            case 1:
                return 'aggregatorPSD2-credentialsKoOneAttempts'
            default:
                return 'aggregatorPSD2-credentialsKoNoAttempts'
        }
    }

    handleGoToEntityCredentials = () => {
        const { bankCode } = this.state;
        this.props.history.push(`/myprofile/global/entities/add/credentials/${bankCode}`)
        recordLink(PROC_AGGREGATOR, PROC_ERROR_RETRY)
    }

    handleGoToOtherBanksSettings = () => {
        this.props.history.push('/myprofile/global/entities/manage')
    }

    render() {
        const { bankName, attempts } = this.state
        attempts < 1 && recordLink(PROC_AGGREGATOR, PROC_AGGREGATOR_RENEW_ENTITY_GO_TO_BLOQUED_USER);

        return (
            <AggregatorAddEntityLayout
                title={formatText('aggregatorAddEntity-renewSessionLayoutTitle')}
                breadCrumb={getBreadCrumbSettings()}
            >
                <OKSectionBox className="aggregator-psd2-credentials col-md-8" title={formatText('aggregatorPSD2-credentialsKoTitle', [bankName || ''])} icon="error">
                    <div className="aggregator-psd2-credentials__information">
                        <FormattedText value="aggregatorPSD2-credentialsKoInformation" />
                    </div>
                    <div className="aggregator-psd2-credentials__attempt-indications">
                        <FormattedText value={this.getPOEditorKey(attempts)} injectedStrings={[attempts || '']} />
                    </div>
                    <div className="aggregator-psd2-credentials__buttons-wrapper">
                        <div className="aggregator-psd2-credentials__left-button">
                            <OKButton modifier="ghost" onClick={this.handleGoToEntityCredentials}>
                                <FormattedText value="aggregatorPSD2-credentialsKoRetryButton" />
                            </OKButton>
                        </div>
                        <div className="aggregator-psd2-credentials__right-button">
                            <OKButton modifier="link-complementary" onClick={this.handleGoToOtherBanksSettings}>
                                <FormattedText value="aggregatorPSD2-goToAggregatorSettings" />
                            </OKButton>
                        </div>
                        <div className="aggregator-psd2-credentials__clear-float" />
                    </div>
                </OKSectionBox>
            </AggregatorAddEntityLayout>
        )
    }
}

AggregatorRenewCredentialsPSD2Ko.propTypes = {
    history: PropTypes.object.isRequired,
}

export default withRouter(AggregatorRenewCredentialsPSD2Ko)
